import React from 'react';

const AboutUs = () => {
    return (
        <div>
            Latarbelakang dan maklumat mengenai organisasi JAIS Ai.
        </div>
    );
};

export default AboutUs;